import type { DatasetDefinition, DatasetKey } from '../types'

export const DATASETS: DatasetDefinition[] = [
  {
    key: 'empreendimentos',
    label: 'Empreendimentos',
    description: 'Regras de cobrança, ramal/rede e tipo de loteamento.',
    searchFields: ['empreendimento', 'primeira_cobranca_agua', 'primeira_cobranca_esgoto', 'segunda_cobranca_agua', 'segunda_cobranca_esgoto', 'ramal_rede', 'tipo_loteamento'],
    titleFields: ['empreendimento'],
    detailFields: ['primeira_cobranca_agua', 'primeira_cobranca_esgoto', 'segunda_cobranca_agua', 'segunda_cobranca_esgoto', 'ramal_rede', 'tipo_loteamento'],
  },
  {
    key: 'suite_help',
    label: 'Suite Help',
    description: 'Ordens de serviço, prazos, custos e orientações operacionais.',
    searchFields: ['codigo', 'ordem_servico', 'assunto', 'custo', 'prazo', 'quem_pode_solicitar', 'canal_solicitacao', 'quando_abrir', 'observacao_ia'],
    titleFields: ['ordem_servico', 'assunto'],
    detailFields: ['custo', 'prazo', 'quem_pode_solicitar', 'canal_solicitacao', 'quando_abrir'],
  },
  {
    key: 'qualificacoes',
    label: 'Qualificações',
    description: 'Padronização de classificações e termos operacionais.',
    searchFields: ['antigo', 'novo', 'categoria', 'confianca', 'observacao'],
    titleFields: ['novo'],
    detailFields: ['antigo', 'categoria', 'confianca', 'observacao'],
  },
  {
    key: 'acionamentos',
    label: 'Acionamentos',
    description: 'Responsáveis da Central de Serviços por setor e função.',
    searchFields: ['codigo', 'setor', 'papel', 'nome', 'email', 'telefone'],
    titleFields: ['setor', 'nome'],
    detailFields: ['papel', 'email', 'telefone'],
  },
  {
    key: 'servicos',
    label: 'Tabela de Serviços',
    description: 'Serviços, condições e tarifas vigentes.',
    searchFields: ['categoria', 'item', 'tarifa'],
    titleFields: ['categoria', 'item'],
    detailFields: ['tarifa'],
  },
  {
    key: 'irregularidades',
    label: 'Irregularidades',
    description: 'Códigos, descrições e valores de irregularidades.',
    searchFields: ['codigo', 'descricao', 'valor'],
    titleFields: ['codigo', 'descricao'],
    detailFields: ['valor'],
  },
]

export const DATASET_MAP = Object.fromEntries(DATASETS.map((item) => [item.key, item])) as Record<DatasetKey, DatasetDefinition>
